/* loader: pull in the wishlist script from the same theme assets path/version */
(function(){try{var cs=document.currentScript;if(!cs){var ss=document.querySelectorAll('script[src*="tyo-crosssell"]');cs=ss[ss.length-1];}if(cs&&cs.src&&!document.getElementById('tyo-wishlist-loader')){var w=document.createElement('script');w.id='tyo-wishlist-loader';w.defer=true;w.src=cs.src.replace('tyo-crosssell','tyo-wishlist');(document.head||document.documentElement).appendChild(w);}}catch(e){}})();
(function(){
  var CDN='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/';
  var CATS=[
    {key:'toran',         label:'Toran',         url:'/collections/toran',         img:'TYO-TOH-027-02.png'},
    {key:'tea-light',     label:'Tea Lights',    url:'/collections/tea-light',     img:'green-hero.png'},
    {key:'charan-padika', label:'Charan Padika', url:'/collections/charan-padika', img:'cp1-overhead.png?v=1789810855'},
    {key:'hanging',       label:'Hangings',      url:'/collections/hanging',       img:'green-pom-pom-bell-hanging-pair-of-2-view-1.png'},
    {key:'mala',          label:'Mala',          url:'/collections/mala',          img:'TYO-MALA-001-03.png'},
    {key:'shubh-labh',    label:'Shubh Labh',    url:'/collections/shubh-labh',    img:'TYO-SHL-012-1.png'}
  ];
  function imgurl(f){ return CDN + f + (f.indexOf('?')>-1?'&':'?') + 'width=500'; }
  function esc(s){ return (s||'').toString().replace(/"/g,'&quot;'); }

  /* ---------------- PDP: category tiles ---------------- */
  var PDP_CSS=
  '.tyo-xcat{font-family:"DM Sans",-apple-system,sans-serif;max-width:1000px;margin:4px auto 24px;padding:16px 14px 2px;border-top:1px solid #EFE4D2}'+
  '.tyo-xcat *{box-sizing:border-box}'+
  '.tyo-xcat__head{text-align:center;margin-bottom:12px}'+
  '.tyo-xcat__eyebrow{display:block;font-size:10px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#C51985;margin-bottom:3px}'+
  '.tyo-xcat__title{font-family:Georgia,serif;font-size:20px;font-weight:700;color:#292323;margin:0}'+
  '.tyo-xcat__grid{display:grid;grid-template-columns:repeat(5,1fr);gap:10px}'+
  '.tyo-xcat__tile{text-decoration:none;display:flex;flex-direction:column;align-items:center;gap:6px}'+
  '.tyo-xcat__frame{width:100%;aspect-ratio:1/1;border-radius:12px;overflow:hidden;border:1px solid #EFE4D2;background:#FDF6E6;box-shadow:0 1px 6px rgba(197,25,133,.05);transition:transform .2s,box-shadow .2s,border-color .2s}'+
  '.tyo-xcat__tile:hover .tyo-xcat__frame{transform:translateY(-3px);border-color:#C51985;box-shadow:0 8px 20px rgba(197,25,133,.16)}'+
  '.tyo-xcat__frame img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .35s}'+
  '.tyo-xcat__tile:hover .tyo-xcat__frame img{transform:scale(1.05)}'+
  '.tyo-xcat__name{font-size:12px;font-weight:700;color:#1C0A00;text-align:center;line-height:1.25}'+
  '@media(max-width:767px){.tyo-xcat{padding:12px 10px 2px;margin:2px auto 14px}.tyo-xcat__head{margin-bottom:8px}.tyo-xcat__grid{grid-template-columns:repeat(5,1fr);gap:6px}.tyo-xcat__tile{gap:4px}.tyo-xcat__title{font-size:16px}.tyo-xcat__eyebrow{font-size:8px;letter-spacing:1px;margin-bottom:2px}.tyo-xcat__name{font-size:9px;line-height:1.15}.tyo-xcat__frame{border-radius:9px}}';

  function normalize(type){
    type=(type||'').toString().toLowerCase();
    if(/charan/.test(type)) return 'charan-padika';
    if(/shubh/.test(type)) return 'shubh-labh';
    if(/mala/.test(type)) return 'mala';
    if(/tea\s*-?\s*light/.test(type)) return 'tea-light';
    if(/toran|tohran/.test(type)) return 'toran';
    if(/hang/.test(type)) return 'hanging';
    return '';
  }
  function findRecs(){
    var sel=['product-recommendations','.product-recommendations','[data-section-type="product-recommendations"]','[id*="product-recommendations"]','[id*="recommendations"]','.related-products','.complementary-products'];
    for(var i=0;i<sel.length;i++){ try{ var el=document.querySelector(sel[i]); if(el){ return el.closest('.shopify-section')||el; } }catch(e){} }
    var heads=document.querySelectorAll('main h2, main h3, #MainContent h2, #MainContent h3, .shopify-section h2, .shopify-section h3');
    for(var j=0;j<heads.length;j++){
      if(heads[j].closest('#tyo-xcat')) continue;
      var t=(heads[j].textContent||'').toLowerCase().replace(/\s+/g,' ').trim();
      if(t.indexOf('you may also')>-1||t.indexOf('you may like')>-1||t.indexOf('you might also')>-1||t.indexOf('recommend')>-1){
        return heads[j].closest('.shopify-section')||heads[j].closest('section')||heads[j].parentElement;
      }
    }
    return null;
  }
  function placeXcat(wrap){
    var recs=findRecs();
    if(recs && recs.parentNode){ recs.parentNode.insertBefore(wrap, recs); return true; }
    return false;
  }
  function renderPDP(curKey){
    if(document.getElementById('tyo-xcat')) return;
    var others=CATS.filter(function(c){return c.key!==curKey;});
    if(others.length>5) others=others.slice(0,5);
    var tiles=others.map(function(c){
      return '<a class="tyo-xcat__tile" href="'+c.url+'"><div class="tyo-xcat__frame"><img src="'+imgurl(c.img)+'" alt="'+esc(c.label)+'" loading="lazy"></div><div class="tyo-xcat__name">'+c.label+'</div></a>';
    }).join('');
    var st=document.createElement('style'); st.textContent=PDP_CSS; document.head.appendChild(st);
    var wrap=document.createElement('div'); wrap.id='tyo-xcat'; wrap.className='tyo-xcat';
    wrap.innerHTML='<div class="tyo-xcat__head"><span class="tyo-xcat__eyebrow">Explore more</span><h2 class="tyo-xcat__title">Shop Other Categories</h2></div><div class="tyo-xcat__grid">'+tiles+'</div>';
    if(placeXcat(wrap)) return;
    var tries=0;
    var iv=setInterval(function(){
      tries++;
      if(placeXcat(wrap)){ clearInterval(iv); return; }
      if(tries>=16){ clearInterval(iv); if(!wrap.parentNode){ (document.getElementById('MainContent')||document.querySelector('main')||document.body).appendChild(wrap); } }
    },150);
  }
  function runPDP(){
    var m=location.pathname.match(/^\/products\/([^\/?#]+)/);
    if(!m) return;
    var t='';
    try{ t=window.ShopifyAnalytics.meta.product.type; }catch(e){}
    if(t){ renderPDP(normalize(t)); return; }
    fetch('/products/'+m[1]+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(p){ renderPDP(normalize(p&&p.type)); })
      .catch(function(){ renderPDP(''); });
  }

  /* ---------------- Collection pages: product cross-sell ---------------- */
  var COL_CSS=
  '.tyo-xsell{font-family:"DM Sans",-apple-system,sans-serif;max-width:1200px;margin:8px auto 48px;padding:26px 16px 4px;border-top:1px solid #EFE4D2}'+
  '.tyo-xsell *{box-sizing:border-box}'+
  '.tyo-xsell__head{text-align:center;margin-bottom:20px}'+
  '.tyo-xsell__eyebrow{display:block;font-size:11px;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;color:#C51985;margin-bottom:6px}'+
  '.tyo-xsell__title{font-family:Georgia,serif;font-size:26px;font-weight:700;color:#292323;margin:0}'+
  '.tyo-xsell__grid{display:grid;grid-template-columns:repeat(5,1fr);gap:18px}'+
  '.tyo-xsell__card{text-decoration:none;display:block;background:#fff;border:1px solid #EFE4D2;border-radius:14px;overflow:hidden;transition:transform .2s,box-shadow .2s}'+
  '.tyo-xsell__card:hover{transform:translateY(-5px);box-shadow:0 14px 32px rgba(197,25,133,.16)}'+
  '.tyo-xsell__media{position:relative;aspect-ratio:1/1;background:#FDF6E6;overflow:hidden}'+
  '.tyo-xsell__media img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .35s}'+
  '.tyo-xsell__card:hover .tyo-xsell__media img{transform:scale(1.06)}'+
  '.tyo-xsell__cat{position:absolute;top:10px;left:10px;background:#C51985;color:#fff;font-size:10px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;padding:5px 10px;border-radius:99px}'+
  '.tyo-xsell__name{font-family:Georgia,serif;font-size:14px;font-weight:600;color:#292323;line-height:1.3;padding:12px 12px 2px;text-align:center}'+
  '.tyo-xsell__price{font-size:13px;font-weight:700;color:#C51985;padding:0 12px 14px;text-align:center}'+
  '@media(max-width:700px){.tyo-xsell__grid{grid-template-columns:repeat(2,1fr);gap:12px}.tyo-xsell__title{font-size:22px}.tyo-xsell{margin-bottom:36px}}';
  function money(v){ var n=parseFloat(v); if(isNaN(n)) return ''; return '₹'+(n%1===0?n.toFixed(0):n.toFixed(2)); }
  function runCollection(){
    var m=location.pathname.match(/^\/collections\/([^\/?#]+)/);
    if(!m) return;
    var cur=m[1];
    var keys=CATS.map(function(c){return c.key;});
    if(keys.indexOf(cur)<0) return;
    if(document.getElementById('tyo-xsell')) return;
    var others=CATS.filter(function(c){return c.key!==cur;});
    Promise.all(others.map(function(c){
      return fetch('/collections/'+c.key+'/products.json?limit=1',{headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(j){return {c:c,p:(j.products&&j.products[0])||null};})
        .catch(function(){return {c:c,p:null};});
    })).then(function(res){
      var cards=res.filter(function(x){return x.p;}).map(function(x){
        var p=x.p;
        var img=(p.images&&p.images[0])?p.images[0].src:'';
        var price=(p.variants&&p.variants[0])?p.variants[0].price:'';
        return '<a class="tyo-xsell__card" href="/products/'+p.handle+'">'+
          '<div class="tyo-xsell__media">'+(img?'<img src="'+img+'" alt="'+esc(p.title)+'" loading="lazy">':'')+
          '<span class="tyo-xsell__cat">'+x.c.label+'</span></div>'+
          '<div class="tyo-xsell__name">'+p.title+'</div>'+
          '<div class="tyo-xsell__price">'+money(price)+'</div></a>';
      }).join('');
      if(!cards) return;
      var st=document.createElement('style'); st.textContent=COL_CSS; document.head.appendChild(st);
      var wrap=document.createElement('div'); wrap.id='tyo-xsell'; wrap.className='tyo-xsell';
      wrap.innerHTML='<div class="tyo-xsell__head"><span class="tyo-xsell__eyebrow">Complete your celebration</span><h2 class="tyo-xsell__title">You may also love</h2></div><div class="tyo-xsell__grid">'+cards+'</div>';
      var main=document.getElementById('MainContent')||document.querySelector('main')||document.body;
      main.appendChild(wrap);
    });
  }

  function run(){ runPDP(); runCollection(); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
})();

/* ===== Tyohaare: header — clean search (icon -> /search), fix mobile logo overlap, hide top cart on mobile ===== */
(function(){
  if(!document.getElementById('tyo-hdrfix-css')){
    var st=document.createElement('style'); st.id='tyo-hdrfix-css';
    st.textContent=
      '.tyo-hdr-search-input{display:none!important}'+
      '@media(max-width:767px){'+
      '.tyo-hdr-logo{position:static!important;left:auto!important;transform:none!important}'+
      '.tyo-hdr-right a.tyo-hdr-icon[href="/cart"]{display:none!important}'+
      '.tyo-hdr-right{gap:2px}'+
      '}';
    (document.head||document.documentElement).appendChild(st);
  }
  function fix(){
    var wrap=document.querySelector('.tyo-hdr-search-wrap'); if(!wrap) return false;
    var inp=wrap.querySelector('.tyo-hdr-search-input, #tyo-search'); if(inp) inp.style.display='none';
    var btn=wrap.querySelector('button, .tyo-hdr-icon');
    if(btn){ btn.onclick=null; btn.style.cursor='pointer';
      btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); window.location.href='/search'; }, true); }
    return true;
  }
  function boot(){ if(!fix()){ var n=0,iv=setInterval(function(){ if(fix()||++n>24) clearInterval(iv); },250); } }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();

/* ===== Tyohaare: collection grid — 2 per row on mobile for every collection except Toran ===== */
(function(){
  var m=location.pathname.match(/^\/collections\/([^\/?#]+)/); if(!m) return;
  if(m[1]==='toran') return;
  function inject(){
    if(document.getElementById('tyo-grid2-css')) return;
    var st=document.createElement('style'); st.id='tyo-grid2-css';
    st.textContent='@media(max-width:749px){ul.product-grid{--mobile-columns:2!important;grid-template-columns:1fr 1fr!important}}';
    document.head.appendChild(st);
  }
  if(document.readyState!=='loading') inject(); else document.addEventListener('DOMContentLoaded',inject);
})();

/* ===== Tyohaare: Toran PDP — 50/60 inch prepaid disclaimer ===== */
(function(){
  if(!/^\/products\//.test(location.pathname)) return;
  function isToran(t){ return /toran|tohran/.test((t||'').toString().toLowerCase()); }
  function render(ok){
    if(!ok || document.getElementById('tyo-toran-note')) return;
    var st=document.createElement('style');
    st.textContent='#tyo-toran-note{font-family:"DM Sans",-apple-system,sans-serif;background:#FBEAF3;border:1px solid #F3CFE3;border-left:3px solid #C51985;border-radius:8px;padding:11px 14px;margin:14px 0;font-size:13px;line-height:1.55;color:#5a4f45}#tyo-toran-note strong{color:#b0187a}';
    document.head.appendChild(st);
    var note=document.createElement('div'); note.id='tyo-toran-note';
    note.innerHTML='<strong>Please note:</strong> 50″ &amp; 60″ Toran sizes are made-to-order and available on <strong>Prepaid orders only</strong> — Cash on Delivery is not available for these sizes.';
    var anchor=document.querySelector('add-to-cart-component, buy-buttons, .buy-buttons, product-form-component, .product-form, [ref="addToCartButtonContainer"]');
    if(anchor && anchor.parentNode){ anchor.parentNode.insertBefore(note, anchor); return; }
    var vp=document.querySelector('variant-picker, .variant-picker'); if(vp && vp.parentNode){ vp.parentNode.insertBefore(note, vp.nextSibling); return; }
    var main=document.querySelector('.product-information, #MainProduct, main'); if(main){ main.insertBefore(note, main.firstChild); }
  }
  var t=''; try{ t=window.ShopifyAnalytics.meta.product.type; }catch(e){}
  if(t){ render(isToran(t)); return; }
  var mm=location.pathname.match(/^\/products\/([^\/?#]+)/);
  if(mm) fetch('/products/'+mm[1]+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(p){ render(isToran(p&&p.type)); }).catch(function(){});
})();

/* ===== Tyohaare: cart popup — 50/60 inch Toran is prepaid only ===== */
(function(){
  if(location.pathname.replace(/\/$/,'')!=='/cart') return;
  function isToran(it){ var t=(it.product_type||'').toLowerCase(); return /toran|tohran/.test(t)||/toran/.test((it.handle||'').toLowerCase()); }
  function is5060(it){
    var parts=(it.variant_title||'')+' ';
    if(it.options_with_values){ parts+=it.options_with_values.map(function(o){return o.value;}).join(' '); }
    return /\b(50|60)\b/.test(parts)||/5[0]\s*(?:inch|in|″|")|6[0]\s*(?:inch|in|″|")/i.test(parts);
  }
  function modal(items){
    if(document.getElementById('tyo-ppd-ov')) return;
    var st=document.createElement('style');
    st.textContent='#tyo-ppd-ov{position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;font-family:"DM Sans",-apple-system,sans-serif}#tyo-ppd{background:#fff;border-radius:16px;max-width:420px;width:100%;padding:26px 24px;box-shadow:0 20px 60px rgba(0,0,0,.3);text-align:center}#tyo-ppd h3{font-family:Georgia,serif;font-size:20px;color:#292323;margin:0 0 10px}#tyo-ppd p{font-size:14px;color:#5a4f45;line-height:1.6;margin:0 0 8px}#tyo-ppd .tyo-ppd-list{background:#FBEAF3;border:1px solid #F3CFE3;border-radius:8px;padding:10px 12px;margin:12px 0;font-size:13px;color:#7a2a55;text-align:left;line-height:1.5}#tyo-ppd .tyo-ppd-btn{margin-top:14px;background:#C51985;color:#fff;border:none;border-radius:8px;padding:12px 26px;font-size:14px;font-weight:700;cursor:pointer}#tyo-ppd .tyo-ppd-icon{font-size:32px;margin-bottom:4px}';
    document.head.appendChild(st);
    var names=items.map(function(it){ return '• '+it.product_title+(it.variant_title?' ('+it.variant_title+')':''); }).join('<br>');
    var ov=document.createElement('div'); ov.id='tyo-ppd-ov';
    ov.innerHTML='<div id="tyo-ppd" role="dialog" aria-modal="true"><div class="tyo-ppd-icon">🪔</div><h3>Prepaid order required</h3><p>Your cart includes a made-to-order Toran in <strong>50″ or 60″</strong>, which is available on <strong>prepaid payment only</strong>.</p><div class="tyo-ppd-list">'+names+'</div><p>Cash on Delivery is not available for these sizes. You can pay securely by UPI, card or netbanking at checkout.</p><button class="tyo-ppd-btn" type="button">Got it, continue</button></div>';
    document.body.appendChild(ov);
    function close(){ ov.remove(); }
    ov.querySelector('.tyo-ppd-btn').addEventListener('click',close);
    ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
  }
  fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
    var hit=(c.items||[]).filter(function(it){ return isToran(it)&&is5060(it); });
    if(hit.length) modal(hit);
  }).catch(function(){});
})();
